import { HOME_FAQ_ITEMS } from "@/shared/constants/homeFaq";
import { CANONICAL_SITE_URL, HOME_PAGE_DESCRIPTION } from "@/shared/constants/seo";
import type { PublicSubscriptionPlan } from "@/shared/services/publicPlansApi";
export const HOME_ENTITY_SUMMARY = {
    heading: "TEZAM — CRM, Telegram Mini App и сайт для бизнеса",
    paragraphs: [
        "TEZAM — платформа ООО «Тезамбай» для работы с клиентами, записью, заказами и командой. CRM связана с клиентским Mini App и веб-витриной.",
        "В каталоге 42 ниши в восьми направлениях. Набор модулей и лимиты зависят от ниши и тарифа. Условия индивидуального сайта и интеграций согласуются отдельно.",
        "Контакты: team@tezam.by; +375 33 918-88-19. ООО «Тезамбай», УНП 193899918. Минск, ул. Некрасова, 114, пом. 84.",
    ],
} as const;
export function homeEntitySummaryPlainText() {
    return [HOME_ENTITY_SUMMARY.heading, ...HOME_ENTITY_SUMMARY.paragraphs].join(" ");
}
export function homeFaqJsonLd() {
    return {
        "@type": "FAQPage",
        "@id": `${CANONICAL_SITE_URL}/#faq`,
        mainEntity: HOME_FAQ_ITEMS.map((x) => ({
            "@type": "Question",
            name: x.question,
            acceptedAnswer: { "@type": "Answer", text: x.answer },
        })),
    };
}
/** Prices use the exact catalog rendered on the page. No fabricated review/rating claims. */
export function homePageJsonLd(plans: PublicSubscriptionPlan[] = []) {
    const orgId = `${CANONICAL_SITE_URL}/#organization`;
    const offers = plans
        .filter((x) => typeof x.amount === "number" && Number.isFinite(x.amount) && x.amount >= 0)
        .map((x) => ({
            "@type": "Offer",
            name: x.name,
            price: x.amount,
            priceCurrency: x.currency || "BYN",
            url: `${CANONICAL_SITE_URL}/tariffs`,
        }));
    return {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": "Organization",
                "@id": orgId,
                name: "TEZAM",
                legalName: "ООО «Тезамбай»",
                taxID: "193899918",
                url: CANONICAL_SITE_URL,
                logo: `${CANONICAL_SITE_URL}/favicon.svg`,
                email: "team@tezam.by",
                telephone: "+375339188819",
                address: {
                    "@type": "PostalAddress",
                    streetAddress: "ул. Некрасова, 114, пом. 84",
                    addressLocality: "Минск",
                    addressCountry: "BY",
                },
            },
            {
                "@type": "WebSite",
                "@id": `${CANONICAL_SITE_URL}/#website`,
                name: "TEZAM",
                url: CANONICAL_SITE_URL,
                inLanguage: "ru-BY",
                publisher: { "@id": orgId },
            },
            {
                "@type": "SoftwareApplication",
                name: "TEZAM",
                applicationCategory: "BusinessApplication",
                operatingSystem: "Web, Telegram",
                url: CANONICAL_SITE_URL,
                description: HOME_PAGE_DESCRIPTION,
                provider: { "@id": orgId },
                ...(offers.length ? { offers } : {}),
            },
            homeFaqJsonLd(),
        ],
    };
}
